import FishBeltForm from './FishBeltForm'

export default FishBeltForm
